var path = '/shared/javascripts/templates/state_select.html';
var html = "<select ng-model=\"bindModel\" id='state-select-dropdown' ng-disabled='disabled'>\n  <option ng-repeat=\"state in states\" value=\"{{ state.code }}\">{{ state.name }}</option>\n</select>";
window.angular.module('tiz').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;